import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../lib/api';

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        await api.post('/analytics/track', {
          page: location.pathname,
          referrer: document.referrer || ''
        });
      } catch {
        // Silently fail
      }
    };
    trackVisit();
  }, [location.pathname]);

  return null;
}
